module.exports = __webpack_public_path__ + "static/img/hxd4yy.a9a66e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hxd4yy.png
// module id = 27Et
// module chunks = 0